module.exports = __webpack_public_path__ + "img/Art08-20110076-001-1280x906.25f15693.jpg";